export const correspondenceConstant = {
    GET_CORRESPONDENCE_DETAIL_REQUEST: "GET_CORRESPONDENCE_DETAIL_REQUEST",
    GET_CORRESPONDENCE_DETAIL_SUCCESS: "GET_CORRESPONDENCE_DETAIL_SUCCESS",
    GET_CORRESPONDENCE_DETAIL_FAILURE: "GET_CORRESPONDENCE_DETAIL_FAILURE",

    CREATE_CORRESPONDENCE_DETAIL_REQUEST: "CREATE_CORRESPONDENCE_DETAIL_REQUEST",
    CREATE_CORRESPONDENCE_DETAIL_SUCCESS: "CREATE_CORRESPONDENCE_DETAIL_SUCCESS",
    CREATE_CORRESPONDENCE_DETAIL_FAILURE: "CREATE_CORRESPONDENCE_DETAIL_FAILURE",

    DELETE_CORRESPONDENCE_DETAIL_REQUEST: "DELETE_CORRESPONDENCE_DETAIL_REQUEST",
    DELETE_CORRESPONDENCE_DETAIL_SUCCESS: "DELETE_CORRESPONDENCE_DETAIL_SUCCESS",
    DELETE_CORRESPONDENCE_DETAIL_FAILURE: "DELETE_CORRESPONDENCE_DETAIL_FAILURE",

    UPDATE_CORRESPONDENCE_DETAIL_REQUEST: "UPDATE_CORRESPONDENCE_DETAIL_REQUEST",
    UPDATE_CORRESPONDENCE_DETAIL_SUCCESS: "UPDATE_CORRESPONDENCE_DETAIL_SUCCESS",
    UPDATE_CORRESPONDENCE_DETAIL_FAILURE: "UPDATE_CORRESPONDENCE_DETAIL_FAILURE",
}